import React from 'react';
import { connect } from 'react-redux';
import TournamentItem from './TournamentItem.js';
import * as Constants from '../../Common/constants.js';
import Footernav from '../Footernav/Footernav.js'



class TournamentsPage extends React.Component {
    
    constructor(props) {

        super(props);
       
        this.state = { data: null, serverErrors: {}, showCompleted:false };
       
        this.selectTournament = this.selectTournament.bind(this);
        this.showCompletedList = this.showCompletedList.bind(this);
        this.showUpcomingList = this.showUpcomingList.bind(this);
        console.info('TournamentsPage - constructor called.');
    }
    static getDerivedStateFromProps(props, state) {
        console.info('TournamentsPage - getDerivedStateFromProps called.');   
        return state;
      }

      getSnapshotBeforeUpdate(prevProps, prevState) {
        console.info('TournamentsPage - getSnapshotBeforeUpdate called.');
        return null;
      }



    componentDidMount() {
        console.info('TournamentsPage - componentDidMount called.');

        this.fetchTournaments();
    }

    

    shouldComponentUpdate() {
        console.info('TournamentsPage - shouldComponentUpdate.');
        return true;
    }

    
    componentDidUpdate() {
    }

    componentWillUnmount() {
        
    }


    onChange(e) {
        console.info('TournamentsPage - onChange called.');
       
    }


    render() {
        console.info('TournamentsPage - render called.', this.props);
        if (!this.state.data){
            return (<div>Loading tournaments</div>);
        }
let banner2 = Constants.IMAGE_SERVER + "/images/banner_small.jpg";
        return (<div style={styles.container}>
            <div className="imageContainer">
             <img className="tournamentBanner" style={{width:'100%', marginTop:'0px'}} src={banner2} />
             <div className="imageText">EUROPEAN TOURNAMENTS</div>
             </div>
             <div className="navmenu -tournamentMenu">
                 <p></p>
                <div className="navmenubar">
                    <h6 style={{paddingRight:"13px", 
                                paddingLeft:"13px",
                                paddingTop: "13px",
                                cursor:"pointer", 
                                borderTop: this.state.showCompleted ? "0px" : "2px solid rgb(195, 172, 116)",
                                color: this.state.showCompleted ? "#7c7c7c" : "white", 
                                borderColor:"#c3ac74"}}  onClick={this.showUpcomingList}>UPCOMING</h6>

                <div style={{}} onClick={this.showCompletedList}>
                    <h6 style={{paddingRight:"13px", 
                                paddingLeft:"13px",
                                paddingTop: "13px",
                                marginLeft: "100px",
                                float:"right", 
                                position:"absolute", 
                                left:0, 
                                cursor:"pointer",
                                borderTop: this.state.showCompleted ? "2px solid rgb(195, 172, 116)" : "0px",
                                color: this.state.showCompleted ? "white" : "#7c7c7c", 
                                borderColor:"#c3ac74"}} >COMPLETED</h6></div></div>
             </div>
             
                <div className="tournaments">
                    {this.state.showCompleted ? this.renderCompletedTournaments(this.state.data):this.renderTournaments(this.state.data)}
                </div>
                
            </div>);
        
    }

    renderTournaments(data){
        console.info('TournamentsPage - renderTournaments', data);
        
        let leaderboards = [];
        var provelement;
        //remove 2019
        data.forEach(element => {
            if(element.state ==="DEMO"){
                element.name = "Global Tournament"
                leaderboards[0]=element;
            }
           /*else if (element.fromDate.indexOf("2021") >= 0){
                leaderboards.push(element);
            }*/
            else if (element.state != "CLOSED"){
                leaderboards.push(element);
            }
           
        });
       
        var i = 0;
        const items = leaderboards.map(x => <TournamentItem key={i++} data={x} onclick={this.selectTournament} />);
        return items;
    }

    customSort(){

    }
    renderCompletedTournaments(data){
        
        console.info('TournamentsPage - renderTournaments', data);
        //const data = data1.slice().sort((a, b) => b.name - a.name)
        
        let leaderboards = [];
        var provelement;
        //remove 2019
        data.forEach(element => {
            if(element.state ==="DEMO"){
                element.name = "Test Tournament"
                leaderboards[0]=element;
            }
           else if (element.state == "CLOSED"){
                leaderboards.push(element);
            }
           
        });
       
        var i = 0;
        const items = leaderboards.map(x => <TournamentItem key={i++} data={x} onclick={this.selectTournament} />);
        return items;
    }
    showCompletedList(){
        console.log("showcompeletedd");
        this.setState({showCompleted:true });
    }
    showUpcomingList(){
        this.setState({showCompleted:false });
    }
    selectTournament(data){
        console.log("tournament selected ", this.props);
        this.props.history.push("/tournament?id=" + data.id)
        
    }
    fetchTournaments() {
        var url = Constants.SERVER + "/leaderboards";
        console.log("TournamentPage fetch ", url);
        fetch(url)
            .then(response => response.json())
            .then(data => {
                data.sort(function (a, b) { return a.from_date - b.from_date });
                this.setState({ data })
            });
    }
}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    userData: state.userData,
    leaderboardData: state.leaderboard,

});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(TournamentsPage);
const styles = {
    container:{

        'textAlign': 'center',
        'fontWeight':'bold',
       
    }
}


// WEBPACK FOOTER //
// ./src/Components/TournamentsPage/index.js